export enum VorlageActionType {
  CREATE_NOTICE = 'CREATE_NOTICE',
  SHOW_PREVIEW = 'SHOW_PREVIEW',
  EXPORT_TEMPLATE = 'EXPORT_TEMPLATE',
  EDIT_TEMPLATE = 'EDIT_TEMPLATE',
  EDIT_TEMPLATE_NAME = 'EDIT_TEMPLATE_NAME',
  COPY_TEMPLATE = 'COPY_TEMPLATE',
  DELETE_TEMPLATE = 'DELETE_TEMPLATE',

  COPY_TEMPLATE_OF_GROUPMEMBER = 'COPY_TEMPLATE_OF_GROUPMEMBER',
  CREATE_NOTICE_FROM_GROUPMEMBER = 'CREATE_NOTICE_FROM_GROUPMEMBER',
}
